'use client';

import dynamic from 'next/dynamic';

// Only when a 404 is actually rendered does its chunk load; see app/not-found.tsx.
const NotFoundContent = dynamic(() => import('./NotFoundContent'));

export default function LazyNotFound() {
    return <NotFoundContent />;
}
